import { useEffect } from 'react';

interface IProps {
  closeTooltip: () => void;
}

/**
 * detect scroll and then close tooltip
 */
const useTooltipScrollCancellation = ({ closeTooltip }: IProps) => {
  useEffect(() => {
    window.addEventListener('scroll', closeTooltip, true);
    return () => window.removeEventListener('scroll', closeTooltip, true);
  }, [closeTooltip]);
};

export default useTooltipScrollCancellation;
